import { EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
var FractionsService = /** @class */ (function () {
    function FractionsService(http, authService) {
        this.http = http;
        this.authService = authService;
        this.onEditEvent = new EventEmitter();
    }
    FractionsService.prototype.getFractionsList = function (params) {
        return this.http.get(environment.apiUrl + "/" + this.authService.getUserType() + "/fraction", { params: params })
            .pipe(map(function (res) { return res; }));
    };
    FractionsService.prototype.getFraction = function (fractionTypeUuid) {
        return this.http.get(environment.apiUrl + "/" + this.authService.getUserType() + "/fraction/" + fractionTypeUuid).pipe(map(function (res) { return res.fraction; }));
    };
    FractionsService.prototype.createFraction = function (fraction) {
        return this.http.post(environment.apiUrl + "/" + this.authService.getUserType() + "/fraction", fraction).pipe(map(function (res) { return res.fraction; }));
    };
    FractionsService.prototype.updateFraction = function (fractionId, fraction) {
        return this.http.put(environment.apiUrl + "/" + this.authService.getUserType() + "/fraction/" + fractionId, fraction);
    };
    FractionsService.prototype.deleteFraction = function (fractionId) {
        return this.http.delete(environment.apiUrl + "/" + this.authService.getUserType() + "/fraction/" + fractionId);
    };
    FractionsService.ngInjectableDef = i0.defineInjectable({ factory: function FractionsService_Factory() { return new FractionsService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService)); }, token: FractionsService, providedIn: "root" });
    return FractionsService;
}());
export { FractionsService };
